module.exports = __webpack_public_path__ + "static/media/afisadx.796d6bb4.png";